const actions = {
  OPEN_SESSION_REQUEST: "OPEN_SESSION_REQUEST",
  OPEN_SESSION_SUCCESS: "OPEN_SESSION_SUCCESS",
  OPEN_SESSION_ERROR: "OPEN_SESSION_ERROR",
  open: (id) => ({
    type: actions.OPEN_SESSION_REQUEST,
    id,
  }),
};
export default actions;
